<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Клиенты</div>
            <a :href="route_create_page" class="title-block__btn btn-add btn-primary btn">Добавить клиента</a>
        </div>
    </div>

<!--    <div class="filter-table">-->
<!--        <div style="width: 34%;" class="filter-table__input-wrap search-control">-->
<!--            <input @keyup.enter="searchClient" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">-->
<!--            <button class="search-control__input-btn reset-btn">-->
<!--                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path-->
<!--                        d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"-->
<!--                        fill="currentColor" />-->
<!--                </svg>-->
<!--            </button>-->
<!--        </div>-->
<!--    </div>-->

    <client-modal
        v-if="showModal"
        :createElement="createElement"
        :requestUrl="route_create"
        @insert="insertClient"
        @closeModal="closeModal"
        @edit="editClient"
        :view_data="currentItem"
        :id="itemId">
    </client-modal>

    <table-element :actions="actions" :thead="thead" :tbody="tbody" @deleteItem="deleteClient" @editItem="updateClient"></table-element>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>

    <list-view></list-view>
</template>

<script>
import TableElement from "../../../elements/TableElement";
import PaginationElement from "../../../elements/PaginationElement";
import ListView from "../../../elements/ListView";
import ChangePage from "../../../helpers/ChangePage";
import Client from "../../../models/Client";
import ClientModal from "../../../modals/ClientModal";
export default {
    name: "ClientComponent",
    components: {ClientModal, PaginationElement, TableElement, ListView},
    props: {
        route_create_page: String,
        route_edit_page: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_update: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            actions: [
                {
                    text: 'Изменить',
                    emit: 'editItem',
                    svg: `<button class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>`
                },
                {
                    text: 'Удалить',
                    emit: 'deleteItem',
                    svg: `<button class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>`
                },
            ],
            thead: [
                'Название',
                'Комментарий'
            ],
            search: '',
            tbody: [],
            count: 1,
            limit: 30,
            page: 1,
            client: new Client({
                route_list: this.route_list,
                route_delete: this.route_delete,
            }),
            showModal: false,
            createElement: false,
            currentItem: {},
            itemId: 0
        }
    },
    watch: {
        search: function() {
            this.loadTable();
        }
    },
    methods: {
        loadTable: async function () {
            let response = await this.client.loadTable(this.page, this.limit, this.search);
            this.tbody = response.tbody;
            this.count = response.pages;
            if(this.page > 1 && this.tbody.length === 0)
            {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        deleteClient: function (params) {
            if(params.hasOwnProperty('id'))
            {
                let id = params.id;
                this.client.delete(id).then(this.loadTable);
                this.showModal = false;
            }
            else
            {
                console.log('Error: delete_item_undefined');
            }
        },
        updateClient: function (params) {
            window.location.href = this.route_edit_page+params.id;
        },
        searchClient: function () {
            this.loadTable();
        }
    },
    mounted() {
        this.page = this.current_page;
        this.loadTable();
    }
}
</script>

<style scoped>

</style>
